import { Box, Grid, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Chart, { useChart } from '../../chart';
import { amber, blue, blueGrey, brown, cyan, deepOrange, deepPurple, green, grey, indigo, lightBlue, lime, orange, pink, purple, red, teal } from '@mui/material/colors';
import { fNumber } from '../../../utils/formatNumber';

const GlobalAppointmentMotiveChart = ({
    first_time_data,
    follow_up_data,
    double_appointments
}) => {

    console.log(follow_up_data)

    return ( 
        <Box>
            <Typography variant='h5' gutterBottom>
                Clasificación por motivo de consulta
            </Typography>
            <Box>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        {first_time_data &&<AnalyticBarChart 
                            title={"Colaboradores de primera vez"}
                            data={first_time_data}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {follow_up_data &&<AnalyticBarChart 
                            title={"Colaboradores de seguimento"}
                            data={follow_up_data}
                        />}
                    </Grid>
                </Grid>
            </Box>
        </Box>
     );
}
 
export default GlobalAppointmentMotiveChart;

const AnalyticBarChart = ({
    title,
    data,
}) => {

    const chartOptions = useChart({
        dataLabels: { 
            enabled:true,
            formatter: (val, opts) => {
                return `${fNumber(val, '0.0')}%`;
            },
        },
        labels: data?.labels??[],
        legend: {
            position:'bottom'
        },
        colors:[
            green[300],
            blue[300],
            purple[300],
            red[300],
            teal[300],
            pink[300],
            amber[300],
            lightBlue[300],
            indigo[300],
            orange[300],
            deepPurple[300],
            orange[300],
            deepOrange[300],
            lime[300],
            cyan[300],
            brown[300],
            blueGrey[200]
        ],
    })

    return(
        <div>
            <Typography variant='subtitle1' align='center'>
                {title}
            </Typography>
            <Typography variant='body2' align='center'>
                Data de {data.users_count} colabaradores
            </Typography>
            <Box sx={{p:2}}>
                <Box
                    sx={{
                        width:'100%',
                        maxWidth:800,
                        margin:'auto'
                    }}
                    
                >
                    <Chart
                        //height={300}
                        type="donut" 
                        series={data.data} 
                        options={chartOptions}
                    />
                </Box>
            </Box>
        </div>
    )
}